import type { OidcIssuer } from '@netfoundry-ui/shared/model';
import { orderBy } from 'lodash';

export const ISSUER_FILTER = 'issuer';
export const JWKS_FILTER = 'jwksUri';

export type OidcIssuerRow = OidcIssuer & { actionList?: string[]; hideSelect?: boolean };

export type OidcIssuerSortKey = 'issuer' | 'jwksUri' | 'active';

/** Keeps the issuers that contain every non-empty filter text, case-insensitively. */
export function filterIssuers(items: OidcIssuerRow[], filters: Record<string, string>): OidcIssuerRow[] {
    const issuer = (filters[ISSUER_FILTER] || '').toLowerCase();
    const jwks = (filters[JWKS_FILTER] || '').toLowerCase();
    return items.filter(
        (row) =>
            (!issuer || (row.issuer || '').toLowerCase().includes(issuer)) &&
            (!jwks || (row.jwksUri || '').toLowerCase().includes(jwks))
    );
}

export function sortIssuers(items: OidcIssuerRow[], key: OidcIssuerSortKey, dir: 'asc' | 'desc'): OidcIssuerRow[] {
    const value = (row: OidcIssuerRow) => (key === 'active' ? (row.active ? 1 : 0) : (row[key] || '').toLowerCase());
    return orderBy(items, [value], [dir]);
}
